import axios from "axios";
import { datesAreOnSameDay, dateStringsOnSameDay, from_YYYYMMDDHHMMSS, prettyDate, to_YYYYMMDDHHMMSS } from "../config/dateFormatting";
import { planeat_user_group_hierarchy } from "../constants/userGroupHierarchy";
import { IServiceUserInfo } from "../datasolvr/ServicesFacade";
import { planEatApi } from "./PlanEatApi";
import { IBookingContent, IBookingItemContent, IConstantAuctionParameters, IDishContent, IEaterGroupContent, IPriceModelContent, IReverseDutchAuctionPriceModelParameters, ISeatingContent, IUserContent, IVersionedObject, PriceModelTypes } from "./PlanEatFacade";
import { reverseDutchAuctionPrice } from "../utils/calculatePrice";
import { IBookedDish, ICheckInBooking, ICheckInBookingItem, IDishesBooked, IMenuItem, IMyBookingsListItem, IMyBookingsListItemDish, ISeatingBookedMenus, ISeatingsBooked, ISelectableSeating, ISelectSeating, IEaterBookings } from "../interface/interface";

export const FrontendApi = {
    getEatersOwnBookings: async (applicationUser: IServiceUserInfo,planEatUser:IVersionedObject<IUserContent>) => {
        var myEaterBookings: IEaterBookings[] = [];
        var bookings: IVersionedObject<IBookingContent>[] = [];
        var seatings: IVersionedObject<ISeatingContent>[] = [];
        var dishes: IVersionedObject<IDishContent>[] = [];


        await planEatApi.getBookings()
            .then(response => {
                bookings = response.data;
            })
            .catch(e => {
                console.log(e)
            });


        await planEatApi.getSeatings()
            .then(response => {
                seatings = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        await planEatApi.getDishes()
            .then(response => {
                dishes = response.data;
            })
            .catch(e => {
                console.log(e)
            });



        bookings.forEach(async (booking) => {
            if(booking.content.userId=== planEatUser.content.id) {
                var seatingStart: string = '';
                var seatingEnd: string = '';
                var seatingName: string = '';
                var myBookingsListOrderedDishes: IMyBookingsListItemDish[] = [];

                if (booking.content.bookingItems.length > 0) {
                    /* Find unique entries */
                    let uniqueBookingItems: IBookingItemContent[] = [];
                    uniqueBookingItems.push(booking.content.bookingItems[0]);
    
                    booking.content.bookingItems.forEach((bookingItem) => {
                        let contains = false;
                        uniqueBookingItems.forEach((uniqueBookingItem) => {
                            if (bookingItem.dishId=== uniqueBookingItem.dishId) {
                                contains = true;
                            }
    
                        })
                        if (!contains) {
                            uniqueBookingItems.push(bookingItem)
                        }
                    })
    
                    for (let i = 0; i < uniqueBookingItems.length; i++) {
                        let quantity = 0;
                        booking.content.bookingItems.forEach(async (bookingItem, index) => {
                            if (uniqueBookingItems[i].dishId=== bookingItem.dishId) {
                                quantity += 1;
                            }
                        })
    
                        dishes.forEach((dish) => {
                            if (dish.content.id=== uniqueBookingItems[i].dishId) {
                                const myBookingsListOrderedDish: IMyBookingsListItemDish = {
                                    'dishId': dish.content.id,
                                    'dishTitle': dish.content.dishTitle,
                                    'dishDescription': dish.content.dishDescription,
                                    'foodCategories': dish.content.foodCategories,
                                    'allergens': dish.content.allergens,
                                    'bookingItemQuantity': quantity,
                                }
                                myBookingsListOrderedDishes.push(myBookingsListOrderedDish);
                            }
                        })
                    }
    
    
                    seatings.forEach((seating) => {
                        if (seating.content.id=== booking.content.seatingId /* && seating.version=== bookingItem.dishVersion */) {
                            seatingStart = seating.content.seatingStart;
                            seatingEnd = seating.content.seatingEnd;
                            seatingName = seating.content.seatingName;
                        }
                    })
    
    
                    if (seatingStart && seatingEnd && seatingName && booking.content.bookingItems.length) {
                        const myEaterBooking: IEaterBookings = {
                            'eaterName': applicationUser.content.name,
                            'bookingId': booking.content.id,
                            'seatingStart': seatingStart,
                            'seatingEnd': seatingEnd,
                            'seatingName': seatingName,
                            'totalNoPeople': booking.content.bookingItems.length,
                            "bookingPricePerServing" : booking.content.bookingPricePerServing,
                            'myBookingsListOrderedDishes': myBookingsListOrderedDishes
                        };
    
                        let tmpBookingDate: Date = from_YYYYMMDDHHMMSS(seatingStart);
                        tmpBookingDate.setHours(tmpBookingDate.getHours() + 1)
                        myEaterBookings.push(myEaterBooking);
                    }
                }   
            }
        })

        return myEaterBookings;

    },
    getEaterBookings: async (showUpComingBooking: boolean, showEarlierBookings: boolean) => { // TODO - remove this method
        var myEaterBookings: IEaterBookings[] = [];
        var bookings: IVersionedObject<IBookingContent>[] = [];
        var seatings: IVersionedObject<ISeatingContent>[] = [];
        var dishes: IVersionedObject<IDishContent>[] = [];
        var today = new Date();
        var users: IVersionedObject<IUserContent>[] = [];
        var applicationUsers: IServiceUserInfo[] = [];
        var eaterApplicationUsers: IServiceUserInfo[] = [];
        var eaterGroupUsers: IVersionedObject<IUserContent>[] = [];

        await planEatApi.getBookings()
            .then(response => {
                bookings = response.data;
            })
            .catch(e => {
                console.log(e)
            });


        await planEatApi.getSeatings()
            .then(response => {
                seatings = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        await planEatApi.getDishes()
            .then(response => {
                dishes = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        await planEatApi.getUsers()
            .then(response => {
                users = response.data;
            })
            .catch(e => {
                console.log(e);
            })

        const userId = localStorage.getItem("userId")

        await planEatApi.getServiceUsers()
        .then(response => {
            applicationUsers = response.data;
        }).catch((response) => {
            console.log(response);
        })

        let user : IVersionedObject<IUserContent> | null = null
        users.forEach(async (tmpUser) => {
            if(tmpUser.content.id=== userId){
                user = tmpUser
            }
        })

        if(user){
            users.forEach(async (tmpUser) => {
                if(tmpUser.content.eaterGroupId=== user?.content.eaterGroupId){
                    eaterGroupUsers.push(tmpUser)
                }
            })
        }

        eaterGroupUsers.forEach((eaterGroupUser) => {
            applicationUsers.forEach((appUser) => {
                if (appUser.content.id === eaterGroupUser.content.applicationUserId) {
                    eaterApplicationUsers.push(appUser);
                }
            })
        })

        eaterGroupUsers.forEach((eaterGroupUser) =>{
            // Find corresponding application user
            var eaterName: string = '';
            applicationUsers.forEach((appUser) => {
                if (appUser.content.id === eaterGroupUser.content.applicationUserId) {
                    eaterName = appUser.content.name
                }
            })

            bookings.forEach(async (booking) => {
                if(booking.content.userId=== eaterGroupUser.content.id) {
                    var seatingStart: string = '';
                    var seatingEnd: string = '';
                    var seatingName: string = '';
                    var myBookingsListOrderedDishes: IMyBookingsListItemDish[] = [];
        
        
                    if (booking.content.bookingItems.length > 0) {
                        /* Find unique entries */
                        let uniqueBookingItems: IBookingItemContent[] = [];
                        uniqueBookingItems.push(booking.content.bookingItems[0]);
        
                        booking.content.bookingItems.forEach((bookingItem) => {
                            let contains = false;
                            uniqueBookingItems.forEach((uniqueBookingItem) => {
                                if (bookingItem.dishId=== uniqueBookingItem.dishId) {
                                    contains = true;
                                }
        
                            })
                            if (!contains) {
                                uniqueBookingItems.push(bookingItem)
                            }
                        })
        
                        for (let i = 0; i < uniqueBookingItems.length; i++) {
                            let quantity = 0;
                            booking.content.bookingItems.forEach(async (bookingItem, index) => {
                                if (uniqueBookingItems[i].dishId=== bookingItem.dishId) {
                                    quantity += 1;
                                }
                            })
        
                            dishes.forEach((dish) => {
                                if (dish.content.id=== uniqueBookingItems[i].dishId) {
                                    const myBookingsListOrderedDish: IMyBookingsListItemDish = {
                                        'dishId': dish.content.id,
                                        'dishTitle': dish.content.dishTitle,
                                        'dishDescription': dish.content.dishDescription,
                                        'foodCategories': dish.content.foodCategories,
                                        'allergens': dish.content.allergens,
                                        'bookingItemQuantity': quantity,
                                    }
                                    myBookingsListOrderedDishes.push(myBookingsListOrderedDish);
                                }
                            })
                        }
        
        
                        seatings.forEach((seating) => {
                            if (seating.content.id=== booking.content.seatingId /* && seating.version=== bookingItem.dishVersion */) {
                                seatingStart = seating.content.seatingStart;
                                seatingEnd = seating.content.seatingEnd;
                                seatingName = seating.content.seatingName;
                            }
                        })
        
        
                        if (seatingStart && seatingEnd && seatingName && booking.content.bookingItems.length) {
                            const myEaterBooking: IEaterBookings = {
                                'eaterName': eaterName,
                                'bookingId': booking.content.id,
                                'seatingStart': seatingStart,
                                'seatingEnd': seatingEnd,
                                'seatingName': seatingName,
                                'totalNoPeople': booking.content.bookingItems.length,
                                "bookingPricePerServing" : booking.content.bookingPricePerServing,
                                'myBookingsListOrderedDishes': myBookingsListOrderedDishes
                            };
        
                            let tmpBookingDate: Date = from_YYYYMMDDHHMMSS(seatingStart);
                            tmpBookingDate.setHours(tmpBookingDate.getHours() + 1)
                            if (showUpComingBooking && tmpBookingDate > today) {
                                myEaterBookings.push(myEaterBooking);
                            }
        
                            if (showEarlierBookings && tmpBookingDate < today) {
                                myEaterBookings.push(myEaterBooking);
                            }
                        }
                    }   
                }
            })
        })
        return myEaterBookings;
    },

    getMyBookingsList: async (showUpcomingBookings: boolean, showEarlierBookings: boolean, bookings: IVersionedObject<IBookingContent>[], seatings: IVersionedObject<ISeatingContent>[], dishes: IVersionedObject<IDishContent>[]) => { // Later have date filter
        var myBookingsList: IMyBookingsListItem[] = [];
        var today = new Date();

        const userId = localStorage.getItem("userId")
        if (userId) {
            bookings.filter(a => a.content.userId === userId).forEach(async (booking) => {
                var seatingStart: string = '';
                var seatingEnd: string = '';
                var seatingName: string = '';
                var myBookingsListOrderedDishes: IMyBookingsListItemDish[] = [];

                let uniqueDishes: IBookingItemContent[] = []
                booking.content.bookingItems.forEach(bookingItem => {
                    if(uniqueDishes.length === 0){
                        uniqueDishes.push(bookingItem)
                    } else {
                        uniqueDishes.includes(bookingItem) && uniqueDishes.push(bookingItem)
                    }
                })

                for (let i = 0; i < uniqueDishes.length; i++) {
                    let quantity = 0;
                    booking.content.bookingItems.forEach(async (bookingItem, index) => {
                        if (uniqueDishes[i].dishId === bookingItem.dishId) {
                            quantity += 1;
                        }
                    })

                    dishes.forEach((dish) => {
                        if (dish.content.id === uniqueDishes[i].dishId) {
                            const myBookingsListOrderedDish: IMyBookingsListItemDish = {
                                'dishId': dish.content.id,
                                'dishTitle': dish.content.dishTitle,
                                'dishDescription': dish.content.dishDescription,
                                'foodCategories': dish.content.foodCategories,
                                'allergens': dish.content.allergens,
                                'bookingItemQuantity': quantity,
                            }
                            myBookingsListOrderedDishes.push(myBookingsListOrderedDish);
                        }
                    })
                }

                seatings.forEach((seating) => {
                    if (seating.content.id === booking.content.seatingId) {
                        seatingStart = seating.content.seatingStart;
                        seatingEnd = seating.content.seatingEnd;
                        seatingName = seating.content.seatingName;
                    }
                })

                if (seatingStart && seatingEnd && seatingName && booking.content.bookingItems.length) {
                    const myBookingListItem: IMyBookingsListItem = {
                        'bookingId': booking.content.id,
                        'seatingStart': seatingStart,
                        'seatingEnd': seatingEnd,
                        'seatingName': seatingName,
                        'totalNoPeople': booking.content.bookingItems.length,
                        'myBookingsListOrderedDishes': myBookingsListOrderedDishes,
                        'bookingComment': booking.content.bookingComment
                    };

                    let tmpBookingDate: Date = from_YYYYMMDDHHMMSS(seatingStart);
                    tmpBookingDate.setHours(tmpBookingDate.getHours() + 1)
                    if (showUpcomingBookings && tmpBookingDate > today) {
                        myBookingsList.push(myBookingListItem);
                    }

                    if (showEarlierBookings && tmpBookingDate < today) {
                        myBookingsList.push(myBookingListItem);
                    }
                }
            })
        }

        return myBookingsList.sort((a, b) => (from_YYYYMMDDHHMMSS(a.seatingStart) > from_YYYYMMDDHHMMSS(b.seatingStart)) ? 1 : (from_YYYYMMDDHHMMSS(a.seatingStart) < from_YYYYMMDDHHMMSS(b.seatingStart)) ? -1 : 0);
    },

    getTodayBookings: async () => { // Later have date filter
        var seatings: IVersionedObject<ISeatingContent>[] = [];
        var dishes: IVersionedObject<IDishContent>[] = [];
        var todaysMenu: IVersionedObject<IDishContent>[] = [];

        await planEatApi.getSeatings()
            .then(response => {
                seatings = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        await planEatApi.getDishes()
            .then(response => {
                dishes = response.data;
            })
            .catch(e => {
                console.log(e)
            });


        var todaysSeatings: IVersionedObject<ISeatingContent>[] = [];
        var dateString = to_YYYYMMDDHHMMSS(new Date())
        seatings.forEach((seating) => {
            if (dateStringsOnSameDay(seating.content.seatingStart, dateString)) {
                todaysSeatings.push(seating)
            }
        })

        todaysSeatings[0].content.seatingDishes.forEach((seatingDish) => {
            dishes.forEach((dish) => {
                if (dish.content.id=== seatingDish.dishId) {
                    todaysMenu.push(dish)
                }
            })
        })
        return todaysMenu;
    },
    checkIfBookedForToday: async () => {
        let today: Date = new Date();
        var bookings: IVersionedObject<IBookingContent>[] = [];
        var seatings: IVersionedObject<ISeatingContent>[] = [];
        var bookedForToday = false;

        await planEatApi.getBookings()
            .then(response => {
                bookings = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        await planEatApi.getSeatings()
            .then(response => {
                seatings = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        var dateString = to_YYYYMMDDHHMMSS(today)
        bookings.forEach((booking) => {
            seatings.forEach((seating) => {
                if (booking.content.seatingId=== seating.content.id) {
                    if (dateStringsOnSameDay(dateString,seating.content.seatingStart)) {
                        bookedForToday = true;
                    }
                }
            })
        })
        return bookedForToday;
    },
    getSeatingsOnDate: async (selectedDate: Date,officeId:string,seatings: IVersionedObject<ISeatingContent>[]) => {
        var dateString = to_YYYYMMDDHHMMSS(selectedDate)

        let seatingsOnSelectedDate: IVersionedObject<ISeatingContent>[] = []
        if (seatings.length !== 0 && selectedDate) {
            seatings.forEach(seating => {
                if(dateStringsOnSameDay(dateString,seating.content.seatingStart) && seating.content.officeId === officeId){
                    seatingsOnSelectedDate.push(seating)
                }
            })
        }

        // Sort dishes
        seatingsOnSelectedDate.sort((a,b) => from_YYYYMMDDHHMMSS(a.content.seatingStart).getTime() - from_YYYYMMDDHHMMSS(b.content.seatingStart).getTime())

        return seatingsOnSelectedDate
    },

    getDishesOnDate: async (selectedDate: Date, seatings: IVersionedObject<ISeatingContent>[], dishes: IVersionedObject<IDishContent>[], bookings?: IVersionedObject<IBookingContent>[]) => {
        const dishesOnDate: IVersionedObject<IDishContent>[] = [];
        var dateString = to_YYYYMMDDHHMMSS(selectedDate)
        
        let seatingsOnSelectedDate: IVersionedObject<ISeatingContent>[] = []
        if (seatings.length !== 0 && selectedDate) {
            seatings.forEach(function (seating) {
                if(dateStringsOnSameDay(dateString,seating.content.seatingStart)){
                    seatingsOnSelectedDate.push(seating)
                }
            });
        }

        let allDishesOnSelectedDate: string[] = []
        if (seatingsOnSelectedDate.length > 0) {
            seatingsOnSelectedDate.forEach((seatingOnSelectedDate) => {
                if (seatingOnSelectedDate.content.seatingDishes) {
                    seatingOnSelectedDate.content.seatingDishes.forEach((seatingDish) => {
                        allDishesOnSelectedDate.push(seatingDish.dishId)
                    })
                }
            })
        }

        // Filter to find unique dishes
        const distinctDishIdsOnSelectedDate = allDishesOnSelectedDate.filter((n, i) => allDishesOnSelectedDate.indexOf(n) === i);

        // Get list of Dishes instead of dishId
        distinctDishIdsOnSelectedDate.forEach((distinctDishIdOnSelectedDate) => {
            dishes.forEach((dish) => {
                if (distinctDishIdOnSelectedDate === dish.content.id) {
                    dishesOnDate.push(dish)
                }
            })
        })

        if(bookings){
            const bookingsOnSelectedDate: IVersionedObject<IBookingContent>[] = []
            seatingsOnSelectedDate.forEach(seatingOnSelectedDate => {
                bookings.forEach(booking => {
                    if(seatingOnSelectedDate.content.id === booking.content.seatingId){
                        bookingsOnSelectedDate.push(booking)
                    }
                })
            })

            const dishesOfBookingsOnSelectedDate: IVersionedObject<IDishContent>[] = [];
            bookingsOnSelectedDate.forEach(bookingOnSelectedDate => {
                bookingOnSelectedDate.content.bookingItems.forEach(bookingItem => {
                    if(!dishesOfBookingsOnSelectedDate.find(dishOfBookingsOnSelectedDate => dishOfBookingsOnSelectedDate.content.id === bookingItem.dishId)){
                        const dish = dishes.find(dish => dish.content.id === bookingItem.dishId)
                        dish && dishesOfBookingsOnSelectedDate.push(dish)
                    }
                })
            })

            dishesOfBookingsOnSelectedDate.forEach(dishOfBookingsOnSelectedDate => {
                const includes = dishesOnDate.includes(dishOfBookingsOnSelectedDate)
                if(!includes){
                    dishesOnDate.push(dishOfBookingsOnSelectedDate)
                }
            })
        }
        
        return dishesOnDate
    },

    getMenuItemsOnDate: async (selectedDate: Date,officeId:string,seatings: IVersionedObject<ISeatingContent>[],dishes: IVersionedObject<IDishContent>[],bookings: IVersionedObject<IBookingContent>[],priceModels: IVersionedObject<IPriceModelContent>[]) => {
        var dateString = to_YYYYMMDDHHMMSS(selectedDate)
        
        let seatingsOnSelectedDate: IVersionedObject<ISeatingContent>[] = []
        if (seatings.length !== 0 && selectedDate) {
            seatings.forEach(function (seating) {
                if(dateStringsOnSameDay(dateString,seating.content.seatingStart)){
                    seatingsOnSelectedDate.push(seating)
                }
            });
        }

        let allDishesOnSelectedDate: string[] = []
        if (seatingsOnSelectedDate.length > 0) {
            seatingsOnSelectedDate.forEach((seatingOnSelectedDate) => {
                if (seatingOnSelectedDate.content.seatingDishes) {
                    seatingOnSelectedDate.content.seatingDishes.forEach((seatingDish) => {
                        allDishesOnSelectedDate.push(seatingDish.dishId)
                    })
                }
            })
        }

        // Filter to find unique dishes
        const distinctDishIdsOnSelectedDate = allDishesOnSelectedDate.filter((n, i) => allDishesOnSelectedDate.indexOf(n) === i);

        // Get list of Dishes instead of dishId
        let distinctDishesOnSelectedDate: IVersionedObject<IDishContent>[] = [];
        distinctDishIdsOnSelectedDate.forEach((distinctDishIdOnSelectedDate) => {
            dishes.forEach((dish) => {
                if (distinctDishIdOnSelectedDate=== dish.content.id) {
                    distinctDishesOnSelectedDate.push(dish)
                }
            })
        })

        let menuItemsOnDate: IMenuItem[] = []
        if (distinctDishesOnSelectedDate.length > 0) {
            distinctDishesOnSelectedDate.forEach(async (distinctDishOnSelectedDate) => {
                var selectableSeatingsOnDish: ISelectableSeating[] = [];
                if (seatingsOnSelectedDate.length > 0) {
                    seatingsOnSelectedDate.forEach((seatingOnSelectedDate) => {
                        if (seatingOnSelectedDate.content.seatingDishes) {
                            seatingOnSelectedDate.content.seatingDishes.forEach((seatingDish) => {
                                if (seatingDish.dishId=== distinctDishOnSelectedDate.content.id) {
                                    let tmpAvailableSeats = seatingOnSelectedDate.content.seatingCapacity;
                                    bookings.forEach((booking) => {
                                        if (booking.content.seatingId=== seatingOnSelectedDate.content.id) {
                                            tmpAvailableSeats -= booking.content.bookingItems.length
                                        }
                                    })
                                    const selectableSeating: ISelectableSeating = {
                                        'seating': seatingOnSelectedDate,
                                        'selected': false,
                                        'avaiableSeats': tmpAvailableSeats
                                    };
                                    selectableSeatingsOnDish.push(selectableSeating)
                                }
                            })
                        }
                    })
                }

                // Calculate price
                var price = 0;
                priceModels.forEach(priceModel => {
                    if(selectableSeatingsOnDish[0].seating.content.priceModelId=== priceModel.content.id){
                        if(priceModel.content.priceModelType=== PriceModelTypes.REVERSE_DUTCH_AUCTION){
                            var reverseDutchAuctionParameters: IReverseDutchAuctionPriceModelParameters = JSON.parse(priceModel.content.priceModelParameters)
                            price = reverseDutchAuctionPrice(reverseDutchAuctionParameters, selectableSeatingsOnDish[0].seating.content)
                        } else if (priceModel.content.priceModelType=== PriceModelTypes.CONSTANT_AUCTION){
                            var constantAutionParameters: IConstantAuctionParameters = JSON.parse(priceModel.content.priceModelParameters)
                            price = constantAutionParameters.price
                        }
                    }
                })

                const myBookingListItem: IMenuItem = {
                    "date":selectedDate,
                    'dish': distinctDishOnSelectedDate,
                    'selectableSeatings': selectableSeatingsOnDish,
                    'quantity': 0,
                    "price": price,
                };

                menuItemsOnDate.push(myBookingListItem)
            })
            // Sort dishes
                menuItemsOnDate.forEach((menuItemOnDate) => {
                menuItemOnDate.selectableSeatings.sort((a, b) => from_YYYYMMDDHHMMSS(a.seating.content.seatingStart).getTime() - from_YYYYMMDDHHMMSS(b.seating.content.seatingStart).getTime())
            })
        }

        return menuItemsOnDate;
    },
    getMenuItemsFromBooking: async (
        booking: IVersionedObject<IBookingContent>,
        bookings: IVersionedObject<IBookingContent>[],
        seatings: IVersionedObject<ISeatingContent>[],
        dishes: IVersionedObject<IDishContent>[],
        officeId: string,
        selectedDate: Date) => {

        var seatingOnOffice = seatings.filter(seating => seating.content.officeId === officeId)

        // Get seatings on selected date
        var dateString = to_YYYYMMDDHHMMSS(selectedDate)
        let seatingsOnSelectedDate: IVersionedObject<ISeatingContent>[] = []
        if (seatingOnOffice.length !== 0 && selectedDate) {
            seatingOnOffice.forEach(function (seating) {
                if(dateStringsOnSameDay(dateString,seating.content.seatingStart)){
                    seatingsOnSelectedDate.push(seating)
                }
            });
        }

        // Get all dishes on date
        let allDishesOnSelectedDate: string[] = []
        if (seatingsOnSelectedDate.length > 0) {
            seatingsOnSelectedDate.forEach((seatingOnSelectedDate) => {
                if (seatingOnSelectedDate.content.seatingDishes) {
                    seatingOnSelectedDate.content.seatingDishes.forEach((seatingDish) => {
                        allDishesOnSelectedDate.push(seatingDish.dishId)
                    })
                }
            })
        }

        // Filter to find unique dishes
        const distinctDishIdsOnSelectedDate = allDishesOnSelectedDate.filter((n, i) => allDishesOnSelectedDate.indexOf(n) === i);

        // Get list of Dishes instead of dishId
        let distinctDishesOnSelectedDate: IVersionedObject<IDishContent>[] = [];
        distinctDishIdsOnSelectedDate.forEach((distinctDishIdOnSelectedDate) => {
            dishes.forEach((dish) => {
                if (distinctDishIdOnSelectedDate=== dish.content.id) {
                    distinctDishesOnSelectedDate.push(dish)
                }
            })
        })

        // Create I menu
        let menuItemsOnDate: IMenuItem[] = []
        if (distinctDishesOnSelectedDate.length > 0) {
            distinctDishesOnSelectedDate.forEach((distinctDishOnSelectedDate) => {
                var selectableSeatingsOnDish: ISelectableSeating[] = [];
                if (seatingsOnSelectedDate.length > 0) {
                    seatingsOnSelectedDate.forEach((seatingOnSelectedDate) => {
                        if (seatingOnSelectedDate.content.seatingDishes) {
                            seatingOnSelectedDate.content.seatingDishes.forEach((seatingDish) => {
                                if (seatingDish.dishId=== distinctDishOnSelectedDate.content.id) {
                                    let tmpAvailableSeats = seatingOnSelectedDate.content.seatingCapacity;
                                    bookings.forEach((booking) => {
                                        if (booking.content.seatingId=== seatingOnSelectedDate.content.id) {
                                            tmpAvailableSeats -= booking.content.bookingItems.length
                                        }
                                    })
                                    const selectableSeating: ISelectableSeating = {
                                        'seating': seatingOnSelectedDate,
                                        'selected': booking.content.seatingId=== seatingOnSelectedDate.content.id,
                                        'avaiableSeats': tmpAvailableSeats
                                    };
                                    selectableSeatingsOnDish.push(selectableSeating)
                                }
                            })
                        }
                    })
                }
                // Select dishes + added quantity
                var tmpDishQuantity = 0;
                booking.content.bookingItems.forEach((bookingItem) => {
                    if (bookingItem.dishId === distinctDishOnSelectedDate.content.id) {
                        tmpDishQuantity++;
                    }
                })
        
                const myBookingListItem: IMenuItem = {
                    "date": selectedDate,
                    'dish': distinctDishOnSelectedDate,
                    'selectableSeatings': selectableSeatingsOnDish,
                    'quantity': tmpDishQuantity,
                    'price': 0,
                    'comment':booking.content.bookingComment
                };
                menuItemsOnDate.push(myBookingListItem)
            })
        }

        // Sort dishes
        menuItemsOnDate.forEach((menuItemOnDate) => {
            menuItemOnDate.selectableSeatings.sort((a, b) => from_YYYYMMDDHHMMSS(b.seating.content.seatingStart).getTime() - from_YYYYMMDDHHMMSS(a.seating.content.seatingStart).getTime())
        })

        return menuItemsOnDate;
    },
    getSelectableSeatings: async (selectedDate: Date, seatingId?: string) => {
        var seatings: IVersionedObject<ISeatingContent>[] = [];
        var bookings: IVersionedObject<IBookingContent>[] = [];


        await planEatApi.getSeatings()
            .then(response => {
                seatings = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        await planEatApi.getBookings()
            .then(response => {
                bookings = response.data;
            })
            .catch(e => {
                console.log(e)
            });


        if (seatingId) {
            // Find seating date
            seatings.forEach((seating) => {
                if (seating.content.id=== seatingId) {
                    selectedDate = from_YYYYMMDDHHMMSS(seating.content.seatingStart);
                }
            })
        }

        // Get seatings on selected date
        var dateString = to_YYYYMMDDHHMMSS(selectedDate)
        let seatingsOnSelectedDate: IVersionedObject<ISeatingContent>[] = []
        if (seatings.length !== 0 && selectedDate) {
            seatings.forEach(function (seating) {
                if(dateStringsOnSameDay(dateString,seating.content.seatingStart)){
                    seatingsOnSelectedDate.push(seating)
                }
            });
        }


        var selectableSeatings: ISelectableSeating[] = [];
        if (seatingsOnSelectedDate.length > 0) {
            seatingsOnSelectedDate.forEach((seatingOnSelectedDate) => {
                let tmpAvailableSeats = seatingOnSelectedDate.content.seatingCapacity;
                bookings.forEach((booking) => {
                    if (booking.content.seatingId=== seatingOnSelectedDate.content.id) {
                        tmpAvailableSeats -= booking.content.bookingItems.length
                    }
                })

                const selectableSeating: ISelectableSeating = {
                    'seating': seatingOnSelectedDate,
                    'selected': false,
                    'avaiableSeats': tmpAvailableSeats
                };
                selectableSeatings.push(selectableSeating)
            })
        }
        return selectableSeatings;
    },
    getDateOfSeatingId: async (seatingId: string) => {
        var allSeatings: IVersionedObject<ISeatingContent>[] = [];
        var seatingsOnSameDateAsSeatingId: IVersionedObject<ISeatingContent>[] = [];

        await planEatApi.getSeatings()
            .then(response => {
                allSeatings = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        let dateOfSeatingId: Date = new Date();
        for (let i = 0; i < allSeatings.length; i++) {
            if (allSeatings[i].content.id=== seatingId) {
                dateOfSeatingId = from_YYYYMMDDHHMMSS(allSeatings[i].content.seatingStart)
                break;
            }
        }
        return dateOfSeatingId;
    },
    getSeatingsBookedOnDate: async (selectedDate: Date,seatings: IVersionedObject<ISeatingContent>[],bookings: IVersionedObject<IBookingContent>[]) => {
        var seatingsBooked: ISeatingsBooked[] = [];

        // Get seatings on selected date
        var dateString = to_YYYYMMDDHHMMSS(selectedDate)
        let seatingsOnSelectedDate: IVersionedObject<ISeatingContent>[] = []
        if (seatings.length !== 0 && selectedDate) {
            seatings.forEach(function (seating) {
                if(dateStringsOnSameDay(dateString,seating.content.seatingStart)){
                    seatingsOnSelectedDate.push(seating)
                }
            });
        }

        seatingsOnSelectedDate.forEach((seatingOnSelectedDate) => {
            var tmpBooked = 0;

            bookings.forEach((booking) => {
                if (booking.content.seatingId=== seatingOnSelectedDate.content.id) {
                    tmpBooked += booking.content.bookingItems.length;
                }
            })

            const selectableSeating: ISeatingsBooked = {
                'seatingId': seatingOnSelectedDate.content.id,
                'seatingTime': prettyDate(seatingOnSelectedDate.content.seatingStart, true, false),
                'seatingName': seatingOnSelectedDate.content.seatingName,
                'booked': tmpBooked,
                'estimated': tmpBooked
            };
            seatingsBooked.push(selectableSeating)
        })

        seatingsBooked.sort((a, b) => {
            let dateA = new Date()
            let dateB = new Date()

            let [aHours,aMinutes] = a.seatingTime.split(":")
            dateA.setHours(parseInt(aHours))
            dateA.setMinutes(parseInt(aMinutes))

            let [bHours,bMinutes] = b.seatingTime.split(":")
            dateB.setHours(parseInt(bHours))
            dateB.setMinutes(parseInt(bMinutes))
            
            return dateA.getTime() - dateB.getTime()
        })

        return seatingsBooked
    },
    getBookingsOnSeating: async (seatingId: string) => {
        var bookings: IVersionedObject<IBookingContent>[] = [];

        await planEatApi.getBookings()
            .then(response => {
                bookings = response.data;
            })
            .catch(e => {
                console.log(e)
            });


        var bookingsOnSeating: IVersionedObject<IBookingContent>[] = [];
        bookings.forEach((booking) => {
            if (booking.content.seatingId === seatingId) {
                bookingsOnSeating.push(booking)
            }
        })
        return bookingsOnSeating;
    },
    getDishesBooked: async (dishesOnDate: IVersionedObject<IDishContent>[],officeId:string,bookings: IVersionedObject<IBookingContent>[],seatings: IVersionedObject<ISeatingContent>[]) => {
        var dishesBooked: IDishesBooked[] = [];

        // Create bookeddishes
        dishesOnDate.forEach((dishOnDate) => {
            var tmpBooked = 0;
            bookings.forEach((booking) => {
                seatings.forEach((seating) => {
                    if(booking.content.seatingId === seating.content.id && seating.content.officeId=== officeId){
                        booking.content.bookingItems.forEach((bookingItem) => {
                            if (bookingItem.dishId === dishOnDate.content.id) {
                                tmpBooked++;
                            }
                        })
                    }
                })

            })

            var tmpDishesBooked: IDishesBooked = {
                dishTitle: dishOnDate.content.dishTitle,
                booked: tmpBooked,
                estimated: tmpBooked
            }
            dishesBooked.push(tmpDishesBooked)
        })
        return dishesBooked;

    }, getSeatingBookedMenus: async (dishesOnDate: IVersionedObject<IDishContent>[], seatingsOnDate: IVersionedObject<ISeatingContent>[],bookings: IVersionedObject<IBookingContent>[]) => {
        var seatingsBookedMenus: ISeatingBookedMenus[] = [];

        // Get unique dishes on date
        seatingsOnDate.forEach((seating) => {
            var tmpBookedDishes: IBookedDish[] = [];
            dishesOnDate.forEach((dish) => {
                var tmpBooked = 0;

                bookings.forEach((booking) => {
                    if (booking.content.seatingId=== seating.content.id) {
                        booking.content.bookingItems.forEach((bookingItem) => {
                            if (bookingItem.dishId=== dish.content.id) {
                                tmpBooked++;
                            }
                        })
                    }
                })
                var tmpBookedDish: IBookedDish = {
                    dishId: dish.content.id,
                    booked: tmpBooked,
                    estimated: tmpBooked
                }
                tmpBookedDishes.push(tmpBookedDish);
            })
            var tmpSeatingBookedMenu = {
                seatingTime: seating.content.seatingStart,
                seatingName: seating.content.seatingName,
                bookedDishes: tmpBookedDishes
            }
            seatingsBookedMenus.push(tmpSeatingBookedMenu)
        })

        // Sort dishes
        seatingsBookedMenus.sort((a, b) => from_YYYYMMDDHHMMSS(a.seatingTime).getTime() - from_YYYYMMDDHHMMSS(b.seatingTime).getTime())
        
        return seatingsBookedMenus
    }, getUnCheckedBookings: async (bookingsOnSeatings: IVersionedObject<IBookingContent>[]) => {
        var checkedInBookings: ICheckInBooking[] = [];
        var eaterGroups: IVersionedObject<IEaterGroupContent>[] = []
        var users: IVersionedObject<IUserContent>[] = []
        var serviceUsers: IServiceUserInfo[] = []
        var dishes: IVersionedObject<IDishContent>[] = []

        await planEatApi.getEaterGroups()
            .then(response => {
                eaterGroups = response.data;
            })
            .catch(e => {
                console.log(e)
            });


        await planEatApi.getUsers()
            .then(response => {
                users = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        await planEatApi.getDishes()
            .then(response => {
                dishes = response.data;
            })
            .catch(e => {
                console.log(e)
            });


        await planEatApi.getServiceUsers()
        .then(response => {
            serviceUsers = response.data;
            // Alphabetically sorted
            serviceUsers.sort((a, b) => a.content.name.localeCompare(b.content.name))
        }).catch((response) => {
            console.log(response);
        })

        bookingsOnSeatings.forEach((bookingOnSeating) => {
            var eaterGroupName = 'Eater group'
            var eaterName = 'name'
            var checkInBookingItems: ICheckInBookingItem[] = []

            // Find own user
            var user : IVersionedObject<IUserContent> | null = null;
            users.forEach((tmpUser) => {
                if(tmpUser.content.id=== bookingOnSeating.content.userId){
                    user = tmpUser
                }
            })

            if(user){
                serviceUsers.forEach((serviceUser) => {
                    if(user){
                        if (serviceUser.content.id=== user.content.applicationUserId) {
                            eaterName = serviceUser.content.name;
                        }
                    }
                })
            }

            // Get eaterGroup
            if(user){
                eaterGroups.forEach((eaterGroup) => {
                    if(user){
                        if (eaterGroup.content.id=== user.content.eaterGroupId) {
                            eaterGroupName = eaterGroup.content.eaterGroupName;
                        }
                    }
                })
            }

        
            // Create check in bookings items
            bookingOnSeating.content.bookingItems.forEach((bookingItem) => {
                if (bookingItem.checkInTime=== undefined) {
                    var tmpDishTitle = ''
                    dishes.forEach((dish) => {
                        if (dish.content.id=== bookingItem.dishId) {
                            tmpDishTitle = dish.content.dishTitle;
                        }
                    })

                    var tmpCheckedInBooking: ICheckInBookingItem = {
                        bookingItemId: bookingItem.bookingItemId,
                        dishTitle: tmpDishTitle
                    }
                    checkInBookingItems.push(tmpCheckedInBooking)
                }
            })

            var tmpCheckedInBooking: ICheckInBooking = {
                booking: bookingOnSeating,
                eaterGroupName: eaterGroupName,
                eaterName: eaterName,
                checkInBookingItems: checkInBookingItems,
            }
            // Add check-in booking only if a person needs checking in
            if (tmpCheckedInBooking.checkInBookingItems.length > 0) {
                checkedInBookings.push(tmpCheckedInBooking)
            }
        })

        // Alphabetically sorted
        checkedInBookings.sort((a, b) => a.eaterGroupName.localeCompare(b.eaterGroupName))

        var currentEaterGroupName: string | undefined = undefined
        var tmpCheckedInBookings: ICheckInBooking[] = []
        var bookingsOfEaterGroup: ICheckInBooking[] = []
        checkedInBookings.forEach((checkInBooking, index) => {
            if(currentEaterGroupName === undefined){
                currentEaterGroupName = checkInBooking.eaterGroupName
            }

            if(currentEaterGroupName !== checkInBooking.eaterGroupName){
                // Alphabetically sorted
                bookingsOfEaterGroup.sort((a, b) => a.eaterName.localeCompare(b.eaterName))
                bookingsOfEaterGroup.forEach(bookingOfEater => {
                    tmpCheckedInBookings.push(bookingOfEater)
                })
                bookingsOfEaterGroup = []
                currentEaterGroupName = checkInBooking.eaterGroupName
                bookingsOfEaterGroup.push(checkInBooking)
            } else {
                bookingsOfEaterGroup.push(checkInBooking)
            }

            if(checkedInBookings.length-1 === index && bookingsOfEaterGroup.length > 0){
                // Alphabetically sorted
                bookingsOfEaterGroup.sort((a, b) => a.eaterName.localeCompare(b.eaterName))
                bookingsOfEaterGroup.forEach(bookingOfEater => {
                    tmpCheckedInBookings.push(bookingOfEater)
                })
            }
        })

        return tmpCheckedInBookings;
    },
    getCheckedBookings: async (bookingsOnSeating: IVersionedObject<IBookingContent>[]) => {
        var checkedInBookings: ICheckInBooking[] = [];
        var eaterGroups: IVersionedObject<IEaterGroupContent>[] = []
        var users: IVersionedObject<IUserContent>[] = []
        var datasolvrUsers: IServiceUserInfo[] = []
        var dishes: IVersionedObject<IDishContent>[] = []

        await planEatApi.getEaterGroups()
            .then(response => {
                eaterGroups = response.data;
            })
            .catch(e => {
                console.log(e)
            });


        await planEatApi.getUsers()
            .then(response => {
                users = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        await planEatApi.getDishes()
            .then(response => {
                dishes = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        await planEatApi.getServiceUsers()
        .then(response => {
            datasolvrUsers = response.data;
        }).catch((response) => {
            console.log(response);
        })

        bookingsOnSeating.forEach((bookingOnSeating) => {
            var eaterGroupName = 'Eater group'
            var eaterName = 'name'
            var checkInBookingItems: ICheckInBookingItem[] = []


           // Find own user
           var user : IVersionedObject<IUserContent> | null = null;
           users.forEach((tmpUser) => {
               if(tmpUser.content.id=== bookingOnSeating.content.userId){
                   user = tmpUser
               }
           })

           if(user){
               datasolvrUsers.forEach((tmpUser) => {
                   if(user){
                       if (tmpUser.content.id=== user.content.applicationUserId) {
                           eaterName = tmpUser.content.name;
                       }
                   }
               })
           }

           // Get eaterGroup
           if(user){
               eaterGroups.forEach((eaterGroup) => {
                   if(user){
                       if (eaterGroup.content.id=== user.content.eaterGroupId) {
                           eaterGroupName = eaterGroup.content.eaterGroupName;
                       }
                   }
               })
           }

            // Create check in bookings items
            bookingOnSeating.content.bookingItems.forEach((bookingItem) => {
                if (bookingItem.checkInTime !== undefined) {
                    var tmpDishTitle = ''
                    dishes.forEach((dish) => {
                        if (dish.content.id=== bookingItem.dishId) {
                            tmpDishTitle = dish.content.dishTitle;
                        }
                    })

                    var tmpCheckedInBooking: ICheckInBookingItem = {
                        bookingItemId: bookingItem.bookingItemId,
                        dishTitle: tmpDishTitle,
                        checkInTime: bookingItem.checkInTime
                    }
                    checkInBookingItems.push(tmpCheckedInBooking)
                }
            })

            var tmpCheckedInBooking: ICheckInBooking = {
                booking: bookingOnSeating,
                eaterGroupName: eaterGroupName,
                eaterName: eaterName,
                checkInBookingItems: checkInBookingItems,
            }
            // Add check-in booking only if a person needs checking in
            if (tmpCheckedInBooking.checkInBookingItems.length > 0) {
                checkedInBookings.push(tmpCheckedInBooking)
            }
        })

         // Alphabetically sorted
         checkedInBookings.sort((a, b) => a.eaterGroupName.localeCompare(b.eaterGroupName))

        return checkedInBookings;
    },
    getSeatingOnDish: async (seatingsOnDate: IVersionedObject<ISeatingContent>[], dish?: IDishContent) => {
        var selectSeatings: ISelectSeating[] = [];


        if (dish) {
            // Get seating
            seatingsOnDate.forEach((seatingOnDate) => {
                let contains = false;
                seatingOnDate.content.seatingDishes.forEach((seatingDish) => {
                    if (seatingDish.dishId=== dish.id) {
                        contains = true;
                    }
                })

                const selectableSeating: ISelectSeating = {
                    'seating': seatingOnDate,
                    'selected': contains
                };
                selectSeatings.push(selectableSeating)
            })
        } else {
            seatingsOnDate.forEach((seatingOnDate) => {
                const selectableSeating: ISelectSeating = {
                    'seating': seatingOnDate,
                    'selected': false
                };
                selectSeatings.push(selectableSeating)
            })
        }

        return selectSeatings
    },
    getAdminUsers: async (officeId: string) => {
        var applicationUsers : IServiceUserInfo[] = []
        var users : IVersionedObject<IUserContent>[] = []

        await planEatApi.getUsers()
            .then(response => {
                users = response.data;
            })
            .catch(e => {
                console.log(e)
            });

        // Filter to only office users
        users = users.filter(user => user.content.officeId === officeId)

        await planEatApi.getServiceUsers()
        .then((response) => {
           response.data.forEach((applicationUser) => {
               var belongsToOffice = false;
                users.forEach(user => {
                    if(user.content.applicationUserId === applicationUser.content.id && user.content.officeId === officeId){
                        belongsToOffice = true;
                    }
                }) 

                if(applicationUser.content.data_raw?.groups && belongsToOffice){
                    var userLevel = 0;

                    applicationUser.content.data_raw?.groups.forEach((group) => {
                        planeat_user_group_hierarchy.forEach((planeat_group) => {
                            if(group=== planeat_group.name){
                                if(planeat_group.hierarchy > userLevel){
                                    userLevel = planeat_group.hierarchy
                                }
                            }
                        })
                    })

                    if(userLevel >= 3){
                        applicationUsers.push(applicationUser)
                    }
                }
            })
        })
        .catch((e) => {
            console.log(e)
        })

        return applicationUsers
    },
}




